import { ImageDropZone } from 'libs/components/drop-zones'

export default function(data, terms) {
  this.updateEndStartDate = (term_id) => {
    var current_term;
    this.terms().map(function(term) {
      if (term['id'] == term_id())
        current_term = term
    })
    this.course().start_date_string(current_term.start_date)
    this.course().end_date_string(current_term.end_date)
  }

  this.maxFilesize = Kadenze.isKadenze ? 2000 : 500;

  this.dummyBool = ko.observable(true); //used to force computed observable to update

  this.enabledFeatures = ko.observableArray([
    'gradebook',
    'attendance',
    'forums',
    'course_gallery',
    'show_mentors_on_syllabus',
    'learning_modules',
    'invite_only',
    'enrollment_external',
    'award_certificates'
  ])

  this.enabledArchivedFeatures = ko.observableArray([
    'participation',
    'submission'
  ]);

  this.course = ko.observable()
  this.terms = ko.observableArray([])
  this.saving = ko.observable(0)
  this.savedAt = ko.observable(false)
  this.changed_flags = {}
  this.instructors_to_notify = ko.observableArray(data.instructors_to_notify)

  this.autosaveOpts = key => {
    return {
      changeCallback: e => {
        this.changed_flags[key] = true
      },

      blurCallback: e => {
        if (this.changed_flags[key]) {
          this.save()
          this.changed_flags[key] = false
        }
      }
    }
  }

  this.initTabs = () => {
    const hash = window.location.hash.substr(1)

    if (hash.length > 0) {
      $('li.kd-tab__tab a[href="#' + hash + '"]').tab('show')
    } else {
      $('li.kd-tab__tab:first-child a').tab('show')
    }

    $('window').scrollTop()
  }

  this.statusLine = ko.pureComputed(() => {
    if (this.course() && this.course().isPublished()) {
      return 'This course has been published'
    } else if (this.course()) {
      return 'This course has not been published'
    } else {
      return ''
    }
  })

  this.noCreditCost = ko.pureComputed(() => {
    return isNaN(this.course().credit_cost()) || this.course().credit_cost() == 0
  })

  this.isCreditCost = ko.pureComputed(() => {
    return isNaN(this.course().credit_cost()) || !this.course().credit_cost()
  })

  this.can_save_send_welcome_message = ko.pureComputed(() => {
    return !!(this.course() && (!_.isEmpty(this.course().welcome_message())))
  })

  this.can_save_notify_instructor_on_enroll = ko.pureComputed(() => {
    return true
  })

  this.can_save_send_coursework_completion_email = ko.pureComputed(() => {
    return true
  })

  this.can_save_send_completion_email = ko.pureComputed(() => {
    return !ko.validation.group(
      this.course().completion_email, { deep: true }
    )().length
  })

  this.certificatesEnabled = ko.pureComputed(() => {
    return this.enabledFeatures().indexOf('award_certificates') > -1
  })

  this.gradebookEnabled = ko.pureComputed(() => {
    return this.enabledFeatures().indexOf('gradebook') > -1
  })

  this.updateSavedTime = () => this.dummyBool(!this.dummyBool())

  this.changeCourseMode = () => {
    this.saveCourseMode()
    return true
  }

  this.saveCourseMode = () => {
    const url = Kadenze.Routes.course_path(this.course().id());
    const method = 'PUT';

    const data = {
      course: {
        adaptive: this.course().adaptive()
      }
    };

    Kadenze.AjaxRequest({
      url,
      type: method,
      data,
      loadingIndicator: true,
      success: (data, textStatus, xhr) => {
        new Kadenze.Notice.success(
          Object.assign(
            {},
            this.defaultNoticeOptions,
            { message: I18n.t('dict.save_success') }
          )
        )
      },

      error: (xhr, textStatus, errorThrown) => {
        new Kadenze.Notice.error(
          Object.assign(
            {},
            this.defaultNoticeOptions,
            { message: xhr.responseJSON.errors }
          )
        )
      }
    })
  }

  this.save = checkFn => {
    if(_.isFunction(this[checkFn]) && !this[checkFn]()) {
      return
    }

    this.saving(this.saving() + 1)
    const data = this.saveableData()

    const request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.course_settings_path(this.course().id()),
      type: 'PATCH',
      data: {course: data},
    })
    
    request.done((data, textStatus, xhr) => {
      // back button issues
      const obj = {course: ko.mapping.toJS(this.course) }
      $('#settings_json').val(JSON.stringify(obj))
    })

    request.success(data => {
      new Kadenze.Notice.success({ message: data.message })
      this.savedAt(new Date())
    })

    request.fail((xhr, textStatus, errorThrown) => {
      const message = xhr.responseJSON ? xhr.responseJSON.errors : I18n.t('notice.unexpected_error')
      new Kadenze.Notice.error({ message: message })
    })

    request.always( () => { this.saving(this.saving() > 0 ? this.saving() - 1 : 0); } )
    this.course().logo_path(null)
  }

  this.saveMessage = ko.computed(() => {
    this.dummyBool();

    if (this.saving()) {
      return 'Saving...'
    } else if (this.savedAt()) {
      return 'Last saved ' + moment(this.savedAt()).fromNow()
    } else {
      return ''
    }
  })

  this.textFieldSave = (_vm, data) => {
    const key = data.target.id

    if(this.changed_flags[key] == true || this.changed_flags[key] == undefined) {
      this.save()
      this.changed_flags[key] = false
    }
  }

  this.bindData = data => {
    //
    // TODO: No idea why course is sometimes nested, sometimes not
    //
    if (data.course) {
      this.course(ko.mapping.fromJS(data.course, this.courseMapping()))
      this._initCourseStatusQueries(data.course)
    } else {
      this.course(ko.mapping.fromJS(data, this.courseMapping()))
      this._initCourseStatusQueries(data)
    }

    this.terms(terms)
    this._initCourseArchiveFeatures()
    this.initPromoDropzone()
    this.initializeSubtitleDropzone()
    this.initLogoDropzone()
    this.initializeCourseCertificateLogoDropzone()
  }

  this.courseMapping = (data) => {
    return {
      create: options => {
        options.data = Object.assign({}, options.data)

        return ko.mapping.fromJS(
          Object.assign(
            options.data,
            {
              'remove_logo': false,
              'remove_course_certificate_logo': false,
              'logo_path': options.data.logo && options.data.logo.url
            }
          ),

          {
            'course_promo_video': {
              'update': opts => {
                if (opts.data)
                  return ko.observable(ko.mapping.fromJS(opts.data))
              }
            }
          }
        )
      },
    }
  }

  this.initLogoDropzone = () => {
    ImageDropZone.for({
      elementName: 'course',

      url: Kadenze.Routes.temp_image_upload_path(),

      currentFile: {
        path: this.course().logo_path()
      },

      message: {
        title: I18n.t('course.logo.dropzone.course_logo'),
        optional: true,
      },

      dropZone: {
        acceptedFiles: '.jpg, .jpeg, .png',
        autoProcessQueue: false,
        previewOptions: {
          containerClass: 'dz-preview--course-card',
        },
      },

      callbacks: {
        thumbnail: () => {},
        sending: () => {},
        success: (file, response) => {
          this.course().logo_path(response.path)
          this.course().remove_logo(false)
          this.save()
        },
        error: (file, errorMessage) => {
          new Kadenze.Notice.error({ message: errorMessage })
          $('#course-img-dz')[0].dropzone.removeAllFiles()
        },
        complete: () => {},
        addedfile: () => {},
        removedfile: file => {
          this.course().remove_logo(true)
          this.course().logo_path(null)
          this.save()
        }
      }
    })

    this.course().logo_path(null)
  }
  
  this.initializeCourseCertificateLogoDropzone = () => {
    const curVid = this.course().course_certificate_logo()

    if (!curVid) {
      var $el = $('#course-certificate-img-dz').addClass('dz-unit');

      var msgText = Kadenze.I18n.t('course.logo.dropzone.add_image', 'en');
      var subMsgText = Kadenze.I18n.t('course.logo.dropzone.max_file_size', 'en');

      var message = JST['templates/dropzone-imagefile']({
          message: msgText,
          subMessage: subMsgText
      });
      var message = JST['templates/dropzone-generic']({
        title: Kadenze.I18n.t('course.logo.dropzone.course_certificate_logo', 'en'),
        maxFilesize: 10,
        optional: true,
        acceptedFiles: '.jpg, .jpeg, .png',
        dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
        dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
        browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
        dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
        maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
        fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
        optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
      });

      var opts = {
        maxFilesize: 10,
        maxThumbnailFilesize: 100,
        dzPreview: JST['templates/dropzone-generic-img-preview']({
          previewable: true,
          containerClass: 'dz-preview-wide',
          nameLabel: Kadenze.I18n.t('file_preview.name'),
          sizeLabel: Kadenze.I18n.t('file_preview.size'),
          previewLabel: Kadenze.I18n.t('file_preview.preview'),
          removeLabel: Kadenze.I18n.t('file_preview.remove_file'),
          fileUploadProgressLabel: Kadenze.I18n.t('file_preview.file_upload_progress'),
        }),
        previewable: true,
        acceptedFiles: '.jpg, .jpeg, .png',
        cropOptions: {
          modalId: 'crop_modal'
        },
        autoProcessQueue: false
      };

      var uploadURL = Kadenze.Routes.temp_image_upload_path();
      var $removeInput = $('#remove_course_certificate_logo');
      const current_tenant = $('#current_institution').val();
      
      const upload_access = JSON.parse($('#settings_json').val()).upload_access;

      var callbacks = {
        thumbnail: () => {},
        sending: () => {},
        success: (file, response) => {
          this.course().course_certificate_logo(response.path)
          this.course().remove_course_certificate_logo(false)
        },
        error: (file, errorMessage) => {
          new Kadenze.Notice.error({ message: errorMessage })
          $('#course-certificate-img-dz')[0].dropzone.removeAllFiles()
        },
        complete: () => {},
        addedfile: (file) => {
          this.initiateDirectUpload(file, current_tenant, upload_access);
        },
        removedfile: file => {
          $removeInput.val('1');
          this.course().course_certificate_logo(null)
          this.course().remove_course_certificate_logo(true)
          this.save()
        }
      };
      
      var curFileObj;
      curFileObj = {
        name: this.course().course_certificate_logo_file_name(),
        size: this.course().course_certificate_logo_file_size()
      };

      if ($el.children().length !== 1){
        var courseDZ = new Kadenze.ImageDropZone($el, message, uploadURL ,callbacks, curFileObj, opts );
      } else{
        $el.children().remove()
        var courseDZ = new Kadenze.ImageDropZone($el, message, uploadURL ,callbacks, curFileObj, opts );
      }
    }
  }

  this.initiateDirectUpload = (file, current_tenant, upload_access) => {
    if (file) {
      var fileName = file.name;
      var key = current_tenant + '/uploads/course/' + Math.floor(Date.now() / 1000) + '/course_certificate_logo/' + fileName;

      // Configure AWS SDK
      AWS.config.update({
        accessKeyId: upload_access.direct_upload_aws_access_key,
        secretAccessKey: upload_access.direct_upload_aws_secret_key,
        region: upload_access.direct_upload_region
      });

      var params = {
        Bucket: upload_access.direct_upload_bucket,
        Key: key,
        Body: file,
        ACL: 'public-read'
        // Add other necessary parameters
      };

      var s3 = new AWS.S3();
      var request = s3.upload(params);

      // Event handlers for upload progress
      request.on('httpUploadProgress', function(evt) {
        var percentComplete = Math.round((evt.loaded / evt.total) * 100);
        // Update Dropzone UI to show upload progress
      });

      // Event handler for upload completion
      request.send((err, data) => {
        if (err) {
          console.log(err);
          $('.file-infos').show();
          $('#cancel-upload-btn').hide();
        } else {
          console.log('Successfully uploaded video.');
          if (data.Location) {
            this.course().course_certificate_logo(data.Location);
            const request = new Kadenze.AjaxRequest({
              url: Kadenze.Routes.course_settings_path(this.course().id()),
              type: 'PATCH',
              data: {course: this.saveableData()},
            })

            request.done((data, textStatus, xhr) => {
              console.log("File uploaded successfully:", data.Location);
            })

            request.success(data => {
              console.log("File uploaded successfully:", data.Location);
            })

            request.fail((xhr, textStatus, errorThrown) => {
              const message = xhr.responseJSON ? xhr.responseJSON.errors : I18n.t('notice.unexpected_error')
              new Kadenze.Notice.error({ message: message })
            })
          }
        }
      });
    }
  }

  this.initPromoDropzone = () => {
    const curVid = this.course().course_promo_video

    if (!curVid || !curVid()) {
      const $el = $('#course-promo-dz')

      if ($el.length && !$el[0].dropzone) {
        $el.addClass('dz-unit')

        let mediaDZ

        const msgText = I18n.t('course.promo_video.dropzone.add_video', 'en')
        const acceptedFiles = '.mp4, .mov, .m4v, .avi'
        const message = JST['templates/dropzone-generic']({
          title: msgText,
          fileTypes: acceptedFiles,
          maxFilesize: this.maxFilesize,
          dropFilesTitle: I18n.t('drop_file_editor.drop_file_title'),
          dragAndDrop: I18n.t('drop_file_editor.drag_and_drop'),
          browseFiles: I18n.t('drop_file_editor.browse_files'),
          dimentionLabel: I18n.t('drop_file_editor.dimensions_label'),
          maxFilesizeLabel: I18n.t('drop_file_editor.max_file_size'),
          fileTypesLabel: I18n.t('drop_file_editor.file_types'),
          optionalLable: I18n.t('drop_file_editor.optional'),
        })

        const previewTemplate = JST['templates/dropzone-media-preview']({status: 'Uploading...'})

        const opts = {
          url: Kadenze.Routes.course_course_promo_videos_path(this.course().id()),
          previewTemplate: previewTemplate,
          autoProcessQueue: true,
          paramName: 'course_promo_video[media_src]',
          acceptedFiles: acceptedFiles,
          maxFilesize: this.maxFilesize,
          maxFiles: 1
        }

        const callbacks = {
          addedfile: () => {},
          success: (file, response) => {
            $('.media-upload-progress-bar-container', file.previewTemplate).hide()
            this.course().course_promo_video(ko.mapping.fromJS(response.files[0].course_promo_video))
            $el[0].dropzone.removeAllFiles()
            $el[0].dropzone.emit('reset')
            this.clearSubtitleDropzone()
            this.initializeSubtitleDropzone()
            this.save()
          },
          uploadprogress: (file, progress, bytesSent) => {
            $('.media-upload-progress-bar', file.previewTemplate).css('width', progress + '%')
          },
          sending: () => { },
          error: (file, errorMessage) => {
            new Kadenze.Notice.error({ parentObject: $el, message: errorMessage })
          },
          complete: () => { },
          removedfile: file => {
            //TODO: Delete the file from the server/db
          }
        }
          // Check to remove duplicate DZ
        if ((curVid || curVid()) && ($el.children().length !== 1)){
          mediaDZ = new Kadenze.MediaDropZone($el, $(message), opts, callbacks, false)
        } else{
          $el.children().remove()
          mediaDZ = new Kadenze.MediaDropZone($el, $(message), opts, callbacks, false)
        }

      }
    }
  }

  this.previewPromoVideo = () => {
    const mediaObj = {
      name: this.course().course_promo_video().name(),
      meta: {
        type: 'video'
      },
      file: {
        url: this.course().course_promo_video().media_src.url()
      }
    }
    Kadenze.MediaFileActions.preview(mediaObj)
  }

  this.previewCourseCertificateLogo = () => {
    const mediaObj = {
      name: "Course Certificate Logo",
      meta: {
        type: 'image'
      },
      file: {
        url: this.course().course_certificate_logo()
      }
    }
    Kadenze.MediaFileActions.preview(mediaObj)
  }

  this.removePromoVideo = element => {
    const vid = this.course().course_promo_video()

    new Kadenze.AjaxRequest({
      type: 'DELETE',
      url: Kadenze.Routes.course_course_promo_video_path(this.course().slug(), vid.id())
    })

    this.course().course_promo_video(null)
    this.initPromoDropzone()
    this.save()
  }

  this.removeCourseCertificateLogo = element => {
    const course_id = this.course().id()
    var $removeInput = $('#remove_course_certificate_logo');

    const request = new Kadenze.AjaxRequest({
      type: 'POST',
      url:  `/courses/${course_id}/remove_course_certificate_logo`
    })

    request.success(data => {
      $removeInput.val('1');
      this.course().course_certificate_logo(null)
      this.course().remove_course_certificate_logo(true)
      this.initializeCourseCertificateLogoDropzone()
      this.save()
    })

    request.fail(data => {
      new Kadenze.Notice.error({ message: data.responseJSON.message })
    })
  }

  this.showAddSubtitlesPane = () => {
    const $button = $('.media-btn__add-subtitles')
    const $pane = $('#add-promo-subs')
    const isClosed = $button.hasClass('closed')

    const class_remove = isClosed ? 'closed' : 'open'
    const class_add = isClosed ? 'open' : 'closed'

    $button.removeClass(class_remove).addClass(class_add)

    if(isClosed) {
      $pane.show()
    } else {
      $pane.hide()
    }
  }

  this.initializeSubtitleDropzone = () => {
    const $dzWrapper = $('#promo-subtitles-dz')
    const $dzSrcLang = $('#promo-subtitles-select')
    const media = this.course().course_promo_video()

    const fileTypes = '.vtt'

    const message = JST['templates/dropzone-standard-message']({
      title: I18n.t('session.media.subtitles_dropzone_prompt'),
      fileTypes: fileTypes
    }
    )

    const $previewTemplate = $(
      I18n.tt(
        JST['templates/dropzone-session-media-preview']({ status: 'uploading' })
      )
    )

    $previewTemplate.css('display', 'none'); //hack to hide preview (dropzone limitation)

    const opts = {
      url: Kadenze.Routes.subtitles_path(),
      previewsContainer: '#promo-video-container',
      previewTemplate: $previewTemplate[0].outerHTML,
      autoProcessQueue: true,
      paramName: 'subtitle[src_file]',
      acceptedFiles: '.vtt',
      maxFiles: 1,
      clickable: true,
      accept: (file, done) => {
        //check for duplicate subtitles
        const srcLang = $dzSrcLang.val()

        const found = _.find(media.subtitles(), subtitle => {
          return subtitle.srclang() === srcLang
        })

        subtitleDZ.options.method = 'POST'
        subtitleDZ.options.url = Kadenze.Routes.subtitles_path()

        if(found) {
          Kadenze.UIUtil.confirmAction(
            I18n.t('session.media.confirm_update_subtitles'),
            () => {
              subtitleDZ.options.method = 'PUT'
              subtitleDZ.options.url = Kadenze.Routes.subtitle_path(found.id())
              done()
            },
            () => done('cancelled')
          )
        }
        else {
          done()
        }
      }
    }

    const callbacks = {
      sending: (file, xhr, formData) => {
        const srcLang = $dzSrcLang.val()
        const srcLabel = $dzSrcLang.find('option:selected').text()

        formData.append('subtitle[srclang]', srcLang)
        formData.append('subtitle[label]', srcLabel)
        formData.append('subtitle[subtitleable_id]', media.id())
        formData.append('subtitle[subtitleable_type]', 'CoursePromoVideo')

        //check for duplicate subtitles
        const found = _.find(media.subtitles(), subtitle => {
          return subtitle.srclang() === srcLang
        })

        if(found) {
          //update instead of new:
          formData.append('subtitle[id]', found.id())
        }
      },
      success: (file, response) => {
        this.updateClientWithSubtitle(response, media)
        this.save()
      },
      error: (file, errorMessage) => {
        if(errorMessage != 'cancelled') {
          new Kadenze.Notice.error({parentObject: $dzWrapper, message: errorMessage})
        }
      },
      complete: file => {
        subtitleDZ.removeFile(file)
      }
    }

    const subtitleDZ = new Kadenze.MediaDropZone($dzWrapper, $(message), opts, callbacks, false)
  }

  this.clearSubtitleDropzone = () => {
    $('#promo-subtitles-dz').empty()
  }

  //add/update ko vm with subtitle
  this.updateClientWithSubtitle = response => {
    const media = this.course().course_promo_video()
    const koNewSub = ko.mapping.fromJS(response.subtitle)

    //new or existing?
    const found = _.find(media.subtitles(), subtitle => {
      return subtitle.id() === koNewSub.id
    })

    if (found) {
      media.subtitles.replace(found, koNewSub)
    } else {
      media.subtitles.push(koNewSub)

      const opts = { src: koNewSub.src_file.url() }

      if(koNewSub.srclang() === 'en')
        opts.default = 'default'
    }
  }

  this.deleteSubtitles = subtitle => {
    const media = this.course().course_promo_video()
    //first delete from server
    Kadenze.UIUtil.confirmAction(
      I18n.t('session.media.confirm_delete_subtitles'),
      () => {
        //post it
        const request = new Kadenze.AjaxRequest({
          method: 'DELETE',
          url: Kadenze.Routes.subtitle_path(subtitle.id())
        })

        request.done(response => {
          //remove from view model
          media.subtitles.remove(subtitle)
        })

        request.fail((xhr, textStatus, errorThrown) => {
          new Kadenze.Notice.error({
            parentObject: $('#session-media-dz').parent(),
            message: xhr.responseJSON.message
          })
        })
      }
    )
  }

  this.deleteCourse = () => {
    const deleteCourse = () => {
      if (this.course().id()) {
        $.ajax({
          type: 'DELETE',
          url: Kadenze.Routes.course_path(this.course().id()),
          data: null,
          dataType: 'json',
          headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
          }
        }).success(data => {
          new Kadenze.Notice.success(
            Object.assign(
              {},
              this.defaultNoticeOptions,
              {
                message: data.message,
                persistent: true
              }
            )
          )

          window.location = data.redirect_path
        }).error(response => {
          new Kadenze.Notice.error(
            Object.assign(
              {},
              this.defaultNoticeOptions,
              {
                message: response.responseJSON.errors
              }
            )
          )
        })
      } else {
        return false
      }
    }

    Kadenze.UIUtil.confirmAction(
      'Are you sure you want to delete this course? All sessions and coursework will also be destroyed.',
      deleteCourse
    )
  }

  this.saveableData = () => {
    const data = ko.mapping.toJS(this.course)

    if (data.enrollment_cutoff_date_string && data.enrollment_cutoff_date_string.trim() !== '') {
      data.enrollment_cutoff_date_string = Kadenze.Util.getMomentDateFromObservable(
        this.course().enrollment_cutoff_date_string
      ).utc().format(
        I18n.t('date.formats.js_default_with_zone')
      )
    }

    if (data.start_date_string && data.start_date_string.trim() !== '') {
      data.start_date_string = Kadenze.Util.getMomentDateFromObservable(
        this.course().start_date_string
      ).utc().format(
        I18n.t('date.formats.js_default_with_zone')
      )
    }

    if (data.end_date_string && data.end_date_string.trim() !== '') {
      data.end_date_string = Kadenze.Util.getMomentDateFromObservable(
        this.course().end_date_string
      ).utc().format(
        I18n.t('date.formats.js_default_with_zone')
      )
    }

    if (this.course().send_welcome_message() && !this.can_save_send_welcome_message())
      data.send_welcome_message = false

    data.start_date = data.start_date_string
    data.end_date = data.end_date_string
    data.instructors_to_notify = data.instructors_to_notify

    delete data.grading_policy_entries
    delete data.lectures
    delete data.lectures_attributes
    delete data.coursework
    delete data.syllabus_sections

    return data
  }

  this.confirmAndUnpublish = () => {
    if (this.course().student_count()) {
      const prompt = 'Are you sure you want to unpublish this course? (Any enrolled students will lose access)'
      Kadenze.UIUtil.confirmAction(prompt, () => this.unpublish())
    } else {
      this.unpublish()
    }
  }

  this.unpublish = () => {
    const request = new Kadenze.AjaxRequest({
      type: 'PATCH',
      url:  Kadenze.Routes.unpublish_course_path(this.course().id()),
      loadingIndicator: {
        container: this.$el,
        positionTop: 'fixed'
      }
    })

    request.success(data => {
      new Kadenze.Notice.success({ message: data.message })
      this.course().status('draft')
    })

    request.fail(data => {
      new Kadenze.Notice.error({ message: data.responseJSON.message })
    })
  }

  this.publish = () => {
    this.course().logo_path(null)

    const data = { course: this.saveableData() },
      type = 'PATCH',
      url = Kadenze.Routes.publish_course_path(this.course().id())

    this.saving(this.saving() + 1)

    const request = Kadenze.AjaxRequest({
      type: type,
      url: url,
      data: data,
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      loadingIndicator: {
        container: this.$el,
        positionTop: 'fixed'
      }
    })

    request.success(data => {
      new Kadenze.Notice.success(
        Object.assign(
          {},
          this.defaultNoticeOptions,
          {
            message: data.message,
            persistent: true
          }
        )
      )

      this.course().status('published')
    })

    request.error(response => {
      new Kadenze.Notice.error(
        Object.assign(
          {},
          this.defaultNoticeOptions,
          {
            message: response.responseJSON.errors
          }
        )
      )
    })

    request.always(() => {
      this.saving(this.saving() > 0 ? this.saving() - 1 : 0)
    })
  }

  this._initCourseStatusQueries = ({ statuses }) => {
    statuses.forEach(this._initCourseStatusQuery)
  }

  this._initCourseStatusQuery = status => {
    this.course()[this._statusPropName(status)] = ko.pureComputed(() => {
      return this.course().status() === status
    })
  }

  this._statusPropName = s => `is${s.replace(/^\w/, c => c.toUpperCase())}`

  this._initCourseArchiveFeatures = () => {
    this._initCourseFeatures()
    this._initEnabledFeatures()

    this.enabledArchivedFeatures(
      this.difference(this.enabledArchivedFeatures(),
        this.disabledArchiveFeatures()
      )
    );
  }

  this._initCourseFeatures = () => {
    if (this.course().settings == null)
      this.course().settings = {}

    if (this.course().settings.features == null)
      this.course().settings.features = {}

    if (this.course().settings.archive == null)
      this.course().settings.archive = {}

    if (!this.course().settings.features.disabled)
      this.course().settings.features.disabled = ko.observableArray([])

  }

  this._initEnabledFeatures = () => {
    this.enabledFeatures(
      this.difference(this.enabledFeatures(),
        this.disabledFeatures()
      )
    );
  }

  this.disabledArchiveFeatures = () => {
    if (typeof this.course().settings.archive.disabled !== 'function')
      this.course().settings.archive.disabled = ko.observableArray([])

    return this.course().settings.archive.disabled()
  }

  this.disabledFeatures = () => {
    return this.course().settings.features.disabled()
  }

  this.difference = (enabledCollection, disabledCollection) => {
    return [enabledCollection, disabledCollection].reduce((a, b) => a.filter(c => !b.includes(c)));
  }

  (() => {
    this.bindData(data)
    this.initTabs()
    
    this.enabledFeatures.subscribe(changes => {
      changes.forEach((ele, idx) => {
        if (ele.status == 'deleted') {
          this.course().settings.features.disabled.push(ele.value)
        } else {
          this.course().settings.features.disabled.remove(ele.value)
        }
      })

      this.save()
    }, null, 'arrayChange')

    this.enabledArchivedFeatures.subscribe(changes => {
      changes.forEach((ele, idx) => {
        if (ele.status == 'deleted') {
          this.course().settings.archive.disabled.push(ele.value)
        } else {
          this.course().settings.archive.disabled.remove(ele.value)
        }
      })

      this.save()
    }, null, 'arrayChange')

    new Array(
      'topic_names', 'total_work_hours', 'premium_text', 'num_credits', 'credit_user_limit',
      'virtual_meeting_room', 'credit_cost', 'meta_info.title',
      'meta_info.description', 'meta_info.keywords', 'name',
      'number', 'end_date_string', 'start_date_string', 'external_id',
      'external_enrollment_button', 'meta_info.price','original_price', 'available_for_days'
    ).forEach(key => {
      const changeFlagKey = key.replace('.', '_')

      this.changed_flags[changeFlagKey] = false

      const prop = Kadenze.Util.objFromString(this.course(), key, ko.observable())

      prop.subscribe(() => this.changed_flags[changeFlagKey] = true);
    })

    new Array(
      'invite_only',
      'enrollment_external',
      'restricted',
      'enrollment_open',
      'skill_level',
      'related_course_master_record_ids',
      'term_id',
      'instructors_to_notify'
    ).forEach(key => this.course()[key].subscribe(() => this.save(false)));

    new Array('send_completion_email', 'send_welcome_message').forEach(key => {
      this.course()[key].subscribe(() => this.save(`can_save_${key}`))
    })

    new Array('notify_instructor_on_enroll').forEach(key => {
      this.course()[key].subscribe(() => this.save(`can_save_${key}`))
    })

    new Array('send_coursework_completion_email').forEach(key => {
      this.course()[key].subscribe(() => this.save(`can_save_${key}`))
    })
    
    this.course().settings.archive.mode.subscribe(() => this.save(false))
    this.course().settings.certificates.distribute_trigger.subscribe(() => this.save(false))
    this.course().settings.certificates.requirements.min_grade.subscribe(() => this.save(false))

    Kadenze.Timers.push(setInterval(this.updateSavedTime, 1000))
  })(this)

  setTimeout(() => {
    (new Kadenze.KdForms()).update()
  }, 200)
}
